import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from "react-router-dom";
import { loginModalOpen } from '../../../actions/Login/login.action';
import { Rnd } from 'react-rnd';
import AdaptiveListAcademy from './components/adaptiveList';
import { Button, Layout, Modal } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import YoutubeComponent from './components/youtube';
import LessonsList from './components/lessonsList'
import ListModal from './components/modal';
import WriteToUs from './components/writeToUs';
import userAPI from '../../../API/user.service.api';
import { academyAPI } from '../../../API/academy.api';
import { StarFilledIcon, MinimizeIcon, MaximizeIcon, CloseIcon, MailIcon } from './academy.svg';
import MotorcyclistandRoute from '../../../../static/img/MotorcyclistandRoute.svg';
import PhonePCGPS from '../../../../static/img/PhonePCGPS.svg';
import { useBeforeunload } from 'react-beforeunload';
import { userRole } from 'app/constants/user.constants.js';
import ShareComponent from './components/share';
import {MenuSvg,CancelSvg} from '../../Desctop/MainMenu/svg';
import { sendNotificationAfterAddedChangeVideo, saveNotFinishedLessons } from './functions';
//CHECK DEVICES
import {isMobileOnly} from 'react-device-detect';
import './academy.css';

const { Header, Sider, Content } = Layout;
const { confirm } = Modal;

export const academyConst = {
    WINDOW: 'window',
    FULL:'full',
    LIST: 'list',
    LESSON: 'lesson',
    DELETE: 'delete',
    EDIT: 'edit',
    ACADEMY_LESSONS: 'academy_lessons',
}

const style = {
    display: "flex",
    alignItems: "center",
    position: 'absolute',
    justifyContent: "center",
    background: "#f0f0f0",
    zIndex: 3000
};

const getDefaultValueParams = () => {
    let data = isMobileOnly || window.innerWidth < 768 ? {
        width: '100%',
        height: '100%',
        x:0,
        y:0,
        size: academyConst.FULL
    } : { 
        width: +window.innerWidth - 100, 
        height: +window.innerHeight - 130, 
        x: 91, 
        y: 105,
        size: academyConst.WINDOW
    };

    return data;
}

const TourstartAcademy = () => {
    const [state, setState] = useState({
        ...getDefaultValueParams(),
        id: null,
        action: null,
        type: null,

        visibleDrawer: false,
        videoTime: 0,

        edit: false,

        modalShow: false,
        shareModalShow: false,
        writeToUsModalShow: false,

        shareType: academyConst.LIST,

        historyData: {},

        newName: '',
        savingLoading: false,

        tabLoad: true,
        activeListKey: 0,
        activeList: {},
        finishedListIds: [],
        certificateIdByListId:[],

        lessonsLoad: true,
        activeLesson: {},
        activeLessonKey: 0,
        finishedLessonsIds: [],
        timeOfNotFinishedLessons: [],
    });

    const [ percent, setPercent ] = useState(0);
    const [ currentTime, setCurrentTime ] = useState(0);
    const [ showDrawerButton, setShowDrawerButton ] = useState(false);
    const [ lists, setLists] = useState([]);
    const [ lessons, setLessons ] = useState([]);

    const history = useHistory();
    const dispatch = useDispatch();
    const intl = useIntl();

    const {isLoggedIn, user, loginLoad} = useSelector(state => state.authentication);
    const { active } = useSelector(store => store.languageData);

    const getLangCode = () => active === 'ru' || active === 'de' ? 'en' : active;

    // useEffect(() => {
    //     console.log(state);
    // }, [state])

    useBeforeunload((event) => {
        if(!isLoggedIn && !loginLoad){
            event.preventDefault();
        }
    })

    const resizeOnClick = (action) => action === academyConst.FULL ? (
        setState({
            ...state, 
            width: +window.innerWidth - 100, 
            height: +window.innerHeight - 130, 
            x: 91, 
            y: 100,
            size: academyConst.WINDOW
        })  
    ) : ( 
        setState({
            ...state, 
            width: 400, 
            height: 300, 
            size: academyConst.WINDOW,  
            x: 91, 
            y: 100
        })
    );
    
    const changeState = (data={}) => { setState({...state,...data}) };

    const changeStateWithSave = (data={}, type=null) => {
        if(isLoggedIn){
            saveProgress(false, {...state, ...data}, type);
        }
        setState({...state,...data})
    }

    const closeOnClick = () => {
        if(!isLoggedIn){
            confirm({
                title: intl.formatMessage({id: 'Log in to save your progress.', defaultMessage: 'Log in to save your progress.'}),
                okText: intl.formatMessage({ id: 'Yes', defaultMessage: 'Yes' }),
                okType: 'danger',
                cancelText: intl.formatMessage({ id: 'No', defaultMessage: 'No' }),
                onOk() {
                    dispatch(loginModalOpen(true));
                    return null;
                },
                onCancel() {
                    history.replace({
                        search: '',
                    })
                },
            });
        } else {
            saveProgress(true);
        }
    }

    const saveProgress = (close = false, newState = state, type=null) => {
        const {activeListKey, finishedListIds, activeLessonKey, finishedLessonsIds, timeOfNotFinishedLessons, certificateIdByListId, historyData} = newState;
        const activeData = { [getLangCode()] : { 
            activeListKey,
            finishedListIds, 
            activeLessonKey,
            finishedLessonsIds, 
            timeOfNotFinishedLessons: type ? timeOfNotFinishedLessons : saveNotFinishedLessons(timeOfNotFinishedLessons, activeLessonKey, percent, currentTime),
            certificateIdByListId
        }};

        const data = {...historyData, ...activeData};

        userAPI.setHistorySelectedData(user.id, academyConst.ACADEMY_LESSONS, data)
        .then(res => console.log(res))
        .then(() => {
            if(close){
                history.replace({
                    search: '',
                });
            }
        })
        .catch(err => console.log(err))
    }

    const getCurrentUserRole = () => {
        return isLoggedIn && user ? user.role : userRole.GUEST;
    }

    const save = (name, videoId='', form) => {
        const {type, action, activeLesson, activeListKey} = state;
        changeState({
            savingLoading: true,
        })
        
        const activeList = lists.filter(item => item.id === activeListKey )[0];
        const activeItem = type === academyConst.LIST ? activeList : activeLesson;
        const deleteItem = action === academyConst.DELETE ? 1 : 0;
        const newTitle = !action || action === academyConst.EDIT ? name : activeItem.title;
        const length = type === academyConst.LIST ? lists.length : lessons.length;

        const data = {
            ...activeItem,
            deleted: deleteItem,
            title: newTitle,
            lang: active === 'ru' || active === 'de' ? 'en' : active,
        };

        if(!action){
            delete data.id;
            delete data.created_at;
            delete data.updated_at;
            delete data.video_duration;
            delete data.deleted;
            delete data.visible;

            data.list_id = type === academyConst.LIST ? 0 : activeListKey;
            data.order_number = length + 1;
            data.video_id = videoId
        }

        academyAPI.save(data)
        .then(res => {
            const {code, response} = res;
            if(code === 200){
                if(!action){
                    if(type === academyConst.LIST){
                        setLists([...lists, response]);
                        changeState({
                            modalShow: false,
                            activeListKey: response['id']
                        });
                    } else {
                        setLessons([...lessons, response]);
                        changeState({
                            modalShow: false,
                            activeLessonKey: response['id'],
                            activeLesson: response
                        });
                        sendNotificationAfterAddedChangeVideo(state.activeListKey, activeList.title)
                    }
                } else {
                    if(type === academyConst.LIST){
                        const index = lists.findIndex(x => x.id === activeListKey);
                        const newPanes = [...lists];
                        newPanes.splice(index, 1, response);
                        setLists([...newPanes]);
                        changeState({
                            modalShow: false,
                        });
                    } else {
                        const index = lessons.findIndex(x => x.id === activeLesson['id']);
                        const newLessons = [...lessons];
                        newLessons.splice(index, 1, response);
                        setLessons([...newLessons]);
                        changeState({
                            modalShow: false,
                        });
                    }
                }
            }
            form.resetFields();
        })
        .catch(err => {
            console.log(err);
            changeState({savingLoading: false})
        })
    }

    useEffect(() => {
        setState({
            ...state,
            activeLesson: {},
            lessonsLoad: true,
            activeListKey: 0,
            activeLessonKey: 0,
            tabLoad: true
        });
        setLessons([]);
        academyAPI.getAllLists(getLangCode())
        .then(res => {
            const {response, code} = res;
            if(code === 200){
                setLists(response);
                setState({
                    ...state,
                    ...state.historyData[getLangCode()],
                    tabLoad: false,
                })
            }
        })
        .catch(err => {
            console.log(err);
            setState({
                ...state,
                tabLoad: false
            })
        })
    },[active])

    useEffect(() => {
        if(!state.tabLoad && isLoggedIn && !loginLoad){
            userAPI.getHistorySelectedData(user.id, academyConst.ACADEMY_LESSONS)
            .then(res => {
                const {code, entities} = res;
                if(code === 200){
                    const data = entities ? JSON.parse(entities) : {};
                    const activeData = data[getLangCode()] ? data[getLangCode()] : {}
                    setState({
                        ...state,
                        historyData: data,
                        ...activeData,
                        activeListKey: data.activeListKey && data.activeListKey > 0 ? data.activeListKey : lists[0] ? lists[0]['id'] : 0,
                    });
                }
            })
            .catch(err => console.log(err))
        } else if(!state.tabLoad && !isLoggedIn && !loginLoad) {
            setState({
                ...state,
                activeListKey: lists[0] ? lists[0]['id'] : 0,
            });
        }
    }, [state.tabLoad, loginLoad, isLoggedIn])

    useEffect(() => {
        if(state.activeListKey > 0){
          academyAPI.getAllLessonsByListId(state.activeListKey)
          .then(res => {
            const {response, code} = res;
            if(code === 200){
                let newActiveLessonKey = state.activeLessonKey > 0 ? state.activeLessonKey : response[0] ? response[0]['id'] : 0;
                let newActiveLesson = response.filter(item => item.id === newActiveLessonKey)[0];
                if(response.length > 0 && !newActiveLesson){
                    newActiveLessonKey = response[0]['id'];
                    newActiveLesson = response[0];
                }
                const notFinishedData = state.timeOfNotFinishedLessons.filter(x => x.id === newActiveLessonKey);
                const percent = notFinishedData[0] ? notFinishedData[0]['percent'] : 0;
                setLessons([...response]);
                setState({
                    ...state,
                    activeLessonKey: newActiveLessonKey, 
                    activeLesson: newActiveLesson,
                    lessonsLoad: false,
                })
                setPercent(percent);
            }
          })  
          .catch(err => {
            console.log(err);
            setState({
                ...state,
                lessonsLoad: false
            })
          })
        }
    },[state.activeListKey]);

    const getEditButton = () => {
        return state.edit ? (
            <Button type="primary" onClick={() => setState({...state, edit: false})} style={{marginRight: 20}}>
                <span>
                    <FormattedMessage id="Save" defaultMessage="Save"/>
                </span>
            </Button>
        ) : (
            <Button type="primary" onClick={() => setState({...state, edit: true})} style={{marginRight: 20}}>
                <span>
                    <FormattedMessage id="Edit" defaultMessage="Edit"/>
                </span>
            </Button>
        )
    }


    const getDrawerButton = () => {
        return(
            <span
                className="drawer_span"
            >
                <Button 
                    className="drawer_btn"   
                    onClick={() => changeState({visibleDrawer: !state.visibleDrawer})}
                >
                    {!state.visibleDrawer ? <MenuSvg /> : <CancelSvg /> }
                </Button>
            </span>
        )
    }

    const getWriteToUsBtn = () => {
        return(
                <Button
                        className="write_to_us_header_btn"
                        onClick={() => changeState({writeToUsModalShow: true})}
                    >
                        <span>
                            <FormattedMessage id="Write to us" defaultMessage="Write to us"/>
                        </span>
                        <MailIcon width="20px" height="20px"/>
                </Button>
        )
    }

    const classForLayout = () => state.width > 1024 ? 'big_window' : 'small_window';
    const classForHeader = () =>  state.width < 500 ? 'small_window_with_hide_header' : '';
    const getMinWindowWidth = () => window.innerWidth < 400 ? '100%' : 400;
    const getMinWindowHeight = () => window.innerHeight < 300 ? '100%' : 300;

    return (
        <Rnd
            style={style}
            minWidth={getMinWindowWidth()}
            minHeight={getMinWindowHeight()}
            size={{ width: state.width, height: state.height }}
            onResize={(e, direction, ref) => setState({...state, width: parseInt(ref.style.width), height:  parseInt(ref.style.height)})}
            onResizeStop={(e, direction, ref, delta, position) => setState({...state, width:  parseInt(ref.style.width), height:  parseInt(ref.style.height)})}
            position={{ x: state.x, y: state.y }}
            onDragStop={(e, d) => setState({ ...state, x: d.x < 0 ? 0 : d.x, y: d.y < 0 ? 0 : d.y })}
            enableResizing={ isMobileOnly || window.innerWidth < 768 ? false : { top:false, right:true, bottom: true, left:true, topRight:false, bottomRight:true, bottomLeft:true, topLeft:true }}
            disableDragging={ isMobileOnly || window.innerWidth < 768 }
            dragHandleClassName="ant-layout-header"
            bounds={'#root'}
        >
             <Layout className={`${state.size} ${classForLayout()} ${classForHeader()}`}>
                <Header>
                    <div>
                        {showDrawerButton ? getDrawerButton() : null}
                        <h1>Tourstart Academy</h1>
                        <div className="title_stars">
                            <StarFilledIcon />
                            <StarFilledIcon />
                            <StarFilledIcon />
                        </div>
                    </div>
                    <img src={PhonePCGPS} className="phone_pc_gps_img" alt="Phone PC GPS" draggable={false} />
                    <img src={MotorcyclistandRoute} className="moto_route_img" alt="Motorcyclist and route" draggable={false}/>
                    <div>
                        {getWriteToUsBtn()}
                        {getCurrentUserRole() === userRole.GM ? getEditButton() : null}
                        <MinimizeIcon width='30px' height='30px' className="minimaze"/>
                        <div className="minimaze_div" onClick={(e) => resizeOnClick(academyConst.WINDOW)}/>
                        <MaximizeIcon width='30px' height='30px' className="maximaze" />
                        <div className="maximaze_div" onClick={(e) => resizeOnClick(academyConst.FULL)}/>
                        <CloseIcon width='22px' height='22px' className="close"/>
                        <div className="close_div" onClick={() => closeOnClick()}/>
                    </div>
                </Header>
                <Layout>
                    <AdaptiveListAcademy
                        state={state} 
                        changeState={changeState}
                        setShowDrawerButton={setShowDrawerButton}
                    >
                        <LessonsList 
                            state={state} 
                            changeState={changeStateWithSave} 
                            loginLoad={loginLoad}
                            percent={percent}
                            setPercent={setPercent}
                            currentTime={currentTime} 
                            setCurrentTime={setCurrentTime}
                            lists={lists}
                            setLists={setLists}
                            lessons={lessons}
                            setLessons={setLessons}
                        />
                    </AdaptiveListAcademy>
                    <Content width="70%">
                        <YoutubeComponent 
                            state={state} 
                            changeStateWithSave={changeStateWithSave} 
                            changeState={changeState}
                            percent={percent}
                            setPercent={setPercent}
                            currentTime={currentTime} 
                            setCurrentTime={setCurrentTime}
                            active={active}
                            lists={lists}
                            lessons={lessons}
                            setLessons={setLessons}
                        />
                    </Content>
                </Layout>
                <ListModal 
                    state={state}
                    changeState={changeState}
                    save={save}
                />
                <ShareComponent 
                    state={state}
                    changeState={changeState}
                    user={user}
                    isLoggedIn={isLoggedIn}
                    lists={lists}
                />
                <WriteToUs 
                    state={state}
                    changeState={changeState}
                    lists={lists}
                />
            </Layout>
        </Rnd>
    )
}


export default TourstartAcademy;